<!--  -->
<template>
  <div class="hellp">
    <div class="logo">
      <img src="../../assets/image/logo.png" alt />
    </div>
    <div class="login_type">
      <div class="student_login" :class="{select: selectType== true}" @click="loginChange(1)">
        验证登录
        <div class="line" v-show="selectType == true"></div>
      </div>
      <div class="company_login" :class="{select: selectType== false}" @click="loginChange(2)">
        密码登录
        <div class="line_two" v-show="selectType == false"></div>
      </div>
    </div>
    <div class="item" v-show="selectType== true">
      <img src="../../assets/image/phone@2x.png" alt />
      <span class="line"></span>
      <input type="number" v-model="getPhone" placeholder="请输入号码" />
    </div>
    <div class="item_two" v-show="selectType== true">
      <div class="left">
        <img src="../../assets/image/Verification code@2x.png" alt />
        <span class="line"></span>
        <input type="number" @input="changeCode" v-model="eyetxt" placeholder="请输入验证码" />
      </div>
      <button
        class="right"
        :style="{backgroundColor:bgColor}"
        v-show="codeType == true"
        @click="sendMsg"
      >{{getCode}}</button>
    </div>
    <div class="item" v-show="selectType== false">
      <img src="../../assets/image/phone@2x.png" alt />
      <span class="line"></span>
      <input type="number" v-model="getPhone" placeholder="请输入号码" />
    </div>
    <div class="item" v-show="selectType== false">
      <img src="../../assets/image/lock.png" class="pwd" alt />
      <span class="line"></span>
      <input type="password" v-model="eyetxt2" placeholder="请输入密码" />
    </div>
    <div class="pwdInfo" v-show="selectType == false">
      <div class="left" @click="forgotPwd">忘记密码?</div>
      <div class="right" @click="rememberPwdOrNo">
        <img
          :src="rememberPwd == true?require('../../assets/image/select.png'):require('../../assets/image/frP.png')"
          alt
        />记住密码
      </div>
    </div>

    <div class="login" @click="login">登录</div>
    <div class="noNumber" @click="register">没有账号? 立即注册></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Dialog } from "vant";
import { Base64 } from "js-base64"; //base64加密
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      getPhone: "",
      eyetxt: "",
      eyetxt2: "",
      selectType: true,
      loginText: "验证码登录",
      getCode: "验证码",
      bgColor: "#2f85ed",
      codeType: true,
      rememberPwd: true
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 登录切换
    loginChange(index) {
      if (index == 1) {
        //学员登录
        this.selectType = true;
        this.type = true;
      } else {
        //企业登录
        this.selectType = false;
        this.type = false;
      }
    },
    // 发送短信
    sendMsg() {
      let time = 60;
      if (this.getCode == "验证码") {
        this.$http
          .sendCode({
            phone: this.getPhone,
            type: 2
          })
          .then(res => {
            if (res.status == 1) {
              let interval = setInterval(() => {
                time--;
                this.getCode = time + "(S)";
                this.bgColor = "#86c3fb";
                if (time <= 0) {
                  clearInterval(interval);
                  this.getCode = "验证码";
                } else {
                  this.bgColor = "#86c3fb";
                }
              }, 1000);
            } else {
              this.$hide.alert({
                message: res.msg
              });
            }
          });
      }
    },
    // 解决复制两次验证码的问题
    changeCode() {
      //解决复制两次
      if (this.eyetxt.length >= 5) {
        this.eyetxt = this.eyetxt.slice(0, 4);
      }
    },
    // 登录
    login() {
      let obj = {};
      let AppId = "wx3c12bf4d3273211b";
      let localUrl = "https://www.jspx0769.com/wx";//线上路径
      // let localUrl = "https://exam.e-stronger.com/wx";//测试路径

      this.$toast.loading({ message: "加载中" });
      // 验证码登录就是账号密码登录
      if (this.selectType == false) {
        this.$http
          .studentPwdLogin({
            phone: this.getPhone,
            password: Base64.encode(this.eyetxt2)
          })
          .then(res => {
            this.$toast.clear();
            if (res.status == 1) {
              obj.login_type = res.data.login_type;
              obj.token = res.data.token;
              // 把token还有登录类型存起来
              localStorage.setItem("token", JSON.stringify(obj));
              if (this.rememberPwd == true) {
                this.setCookie(this.getPhone, this.eyetxt2, 7);
              }

              Dialog.alert({
                message: res.msg,
                confirmButtonText: "确认"
              }).then(() => {
                // on close
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                  AppId +
                  "&redirect_uri=" +
                  encodeURIComponent(localUrl) +
                  "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
                Dialog.close();

                // this.$router.push({ path: "/" });
              });
            } else if (res.status == 5000) {
              Dialog.confirm({
                title: "提示",
                message: res.msg,
                confirmButtonText: "立即注册",
                cancelButtonText: "返回"
              })
                .then(() => {
                  this.$router.push({ path: "/chooseUserOrCompany" });
                })
                .catch(() => {
                  // on cancel
                });
            } else {
              Dialog.alert({
                message: res.msg,
                confirmButtonText: "确认"
              });
            }
          });
      } else if (this.selectType == true) {
        this.$http
          .studentSmsLogin({
            phone: this.getPhone,
            code: this.eyetxt
          })
          .then(res => {
            this.$toast.clear();
            if (res.status == 1) {
              obj.login_type = res.data.login_type;
              obj.token = res.data.token;
              // 把token还有登录类型存起来
              localStorage.setItem("token", JSON.stringify(obj));
              Dialog.alert({
                message: res.msg,
                confirmButtonText: "确认"
              }).then(() => {
                // on close
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                  AppId +
                  "&redirect_uri=" +
                  encodeURIComponent(localUrl) +
                  "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
                // this.$router.push({ path: "/" });
              });
            } else if (res.status == 5000) {
              Dialog.confirm({
                title: "提示",
                message: res.msg,
                confirmButtonText: "立即注册",
                cancelButtonText: "返回"
              })
                .then(() => {
                  this.$router.push({ path: "/chooseUserOrCompany" });
                })
                .catch(() => {
                  // on cancel
                });
            } else {
              Dialog.alert({
                message: res.msg,
                confirmButtonText: "确认"
              });
            }
          });
      }
    },
    // 去注册
    register() {
      this.$router.push({ path: "/studentRegister" });
    },
    // 忘记密码
    forgotPwd() {
      this.$router.push({ path: "/forgotPwd" });
    },
    // 记住密码
    rememberPwdOrNo() {
      this.rememberPwd = !this.rememberPwd;
    },

    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },

    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.getPhone = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.eyetxt2 = arr2[1];
          }
        }
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getCookie();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
html,
body {
  width: 100%;
  height: 100vh;
}
.hellp {
  // padding-top: 89px;
  width: 100%;
  background: url("../../assets/image/bj.png");
  height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // overflow: hidden;
  box-sizing: border-box;
  padding: 50px 20px 0;
  .logo {
    width: 173px;
    height: 103px;
    margin: 0 auto 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login_type {
    width: 100%;
    display: flex;
    .student_login {
      flex: 1;
      text-align: center;
      color: #999999;
      border-bottom: 1px solid #dddddd;
      padding: 12px 0;
      font-size: 20px;
      position: relative;
      .line {
        width: 80%;
        height: 2px;
        background-color: #2f85ed;
        position: absolute;
        bottom: -1px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .company_login {
      flex: 1;
      text-align: center;
      color: #999999;
      border-bottom: 1px solid #dddddd;
      padding: 12px 0;
      font-size: 20px;
      position: relative;
      .line_two {
        width: 80%;
        height: 2px;
        background-color: #2f85ed;
        position: absolute;
        bottom: -1px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .select {
      color: #2f85ed;
    }
  }
  .pwdInfo {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 15px auto 0;
    .left {
      font-size: 14px;
      color: #666666;
    }
    .right {
      font-size: 14px;
      color: #666666;

      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }
  .login {
    width: 100%;
    background-color: #2f85ed;
    border-radius: 8px;
    border: none;
    font-size: 19px;
    color: #fff;
    height: 46px;
    text-align: center;
    line-height: 46px;
    margin: 60px auto 0;
  }
  .noNumber {
    text-align: center;
    font-size: 16px;
    color: #2f85ed;
    margin-top: 20px;
  }
  .item {
    width: 100%;
    // padding: 3px 0;
    background-color: #fff;
    // box-sizing: border-box;
    height: 45px;
    margin-top: 23px;
    border-radius: 8px;
    input {
      width: 60%;
      border: none;
      height: 30px;
      font-size: 17px;
      vertical-align: middle;
      padding-left: 13px;
    }
    .line {
      width: 1px;
      height: 20px;
      display: inline-block;
      background-color: #dddddd;
      margin-left: 16px;
      vertical-align: middle;
    }
    img {
      width: 24px;
      height: 23px;
      vertical-align: middle;
      margin-left: 15px;
    }
    .pwd {
      width: 22px;
      height: 23px;
      margin-left: 17px;
    }
  }
  .item_two {
    width: 100%;
    margin-top: 23px;
    overflow: hidden;
    .left {
      width: 70%;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 8px;
      float: left;
      // padding: 3px 0;
      height: 45px;
      input {
        width: 60%;
        border: none;
        height: 30px;
        font-size: 17px;
        vertical-align: middle;
        padding-left: 13px;
      }
      .line {
        width: 1px;
        height: 20px;
        display: inline-block;
        background-color: #dddddd;
        margin-left: 16px;
        vertical-align: middle;
      }
      img {
        width: 22px;
        height: 23px;
        vertical-align: middle;
        margin-left: 17px;
      }
    }
    .right {
      width: 27%;
      height: 45px;
      border: none;
      float: right;
      background-color: #2f85ed;
      border-radius: 8px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 45px;
    }
  }
}
</style>